import { IStyle } from '@fluentui/react';
import { IH2OTheme } from '@h2oai/ui-kit';

export interface IGrantPermissionStyles {
  root?: IStyle;
  form?: IStyle;
  fields?: IStyle;
  buttons?: IStyle;
}

export interface IGrantPermissionClassNames {
  root: string;
  form: string;
  fields: string;
  buttons: string;
}

export const grantPermissionStylesDefault = (_theme: IH2OTheme): Partial<IGrantPermissionStyles> => ({
  root: {
    flex: 1,
    height: '100%',
    paddingTop: 17,
  },
  form: { height: '100%', display: 'flex', flexDirection: 'column', minHeight: 0 },
  fields: {
    flex: 1,
    display: 'flex',
    flexDirection: 'column',
    gap: 20,
  },
  buttons: { textAlign: 'right' },
});
